<script setup lang="ts">
import { select, arc, interpolate } from 'd3';
import { onMounted, ref, watchEffect } from 'vue';

const props = defineProps<{
  title: string;
  disableAnimation?: boolean;
  inPopup?: boolean;
}>();

const svgRef = ref<SVGElement | null>(null);
let oldAngle = 0;

onMounted(() => {
  const svg = select(svgRef.value);

  watchEffect(() => {
    svg.selectAll('*').remove();
    const gauge = arc().cornerRadius(30).startAngle(0);

    svg
      .append('path')
      .datum({
        endAngle: Math.PI * 2,
        innerRadius: 80,
        outerRadius: 90,
      })
      .attr('fill', '#F9F9F9')
      .attr('d', gauge as any);

    const foreground = svg
      .append('path')
      .datum({
        endAngle: oldAngle,
        innerRadius: 75,
        outerRadius: 90,
      })
      .attr('fill', props.disableAnimation ? '#f5f5f5' : 'url(#line-gradient)')
      .attr('d', gauge as any);

    svg
      .append('rect')
      .attr('transform', 'translate(-40, -30)')
      .attr('rx', 10)
      .attr('ry', 10)
      .attr('width', 80)
      .attr('height', 20)
      .attr('class', 'xs:h-[15px] xl:h-auto')
      .attr('fill', props.disableAnimation ? '#f5f5f5' : 'url(#line-gradient)');

    svg
      .append('rect')
      .attr('transform', 'translate(-30, 5)')
      .attr('rx', 10)
      .attr('ry', 10)
      .attr('width', 60)
      .attr('height', 20)
      .attr('class', 'xs:h-[15px] xl:h-auto')
      .attr('fill', props.disableAnimation ? '#f5f5f5' : 'url(#line-gradient)');

    svg
      .append('rect')
      .attr('transform', 'translate(-50, 105)')
      .attr('rx', 10)
      .attr('ry', 10)
      .attr('width', 100)
      .attr('height', 20)
      .attr('class', 'xs:h-[15px] xl:h-auto')
      .attr('fill', props.disableAnimation ? '#f5f5f5' : 'url(#line-gradient)');

    svg
      .append('rect')
      .attr('transform', 'translate(-50, 135)')
      .attr('rx', 10)
      .attr('ry', 10)
      .attr('width', 100)
      .attr('height', 20)
      .attr('class', 'xs:h-[15px] xl:h-auto')
      .attr('fill', props.disableAnimation ? '#f5f5f5' : 'url(#line-gradient)');

    const angle = (Math.PI / 180) * 40;
    oldAngle = angle;

    if (import.meta.env.VITE_DISABLE_ANIMATION != 'true') {
      const anim = foreground.transition().delay(500).duration(1000);
      anim.call((transition, newAngle) => {
        transition.attrTween('d', (d) => {
          const fill = interpolate(d.endAngle, newAngle);
          return (t) => {
            d.endAngle = fill(t);
            return gauge(d as any) as any;
          };
        });
      }, angle);
    } else {
      // if we are disabling animations just skip directly to the value
      foreground.attr('d', (d) => {
        d.endAngle = angle;
        return gauge(d as any) as any;
      });
    }
  });
});
</script>
<template>
  <svg :class="'xl:w-[33%] h-full xs:w-[50%]'" viewBox="-125 -95 260 300">
    <g ref="svgRef"></g>
  </svg>
</template>
